import { useFormik } from "formik";
import { useState } from "react";
import { toast } from "react-toastify";
import { uploadOldCertificateExcel } from "../../api";

const EXCEL_FILE_TYPES = [
  ".csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];

const useExcelUpload = ({ receiptId, handleClose, onUploaded }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      excel_file: "",
    },
    onSubmit: async (values) => {
      if (!values?.excel_file) {
        formik.setFieldError("excel_file", "Please choose an excel file");
        return;
      }
      if (!receiptId) {
        toast.error("Select a stock receipt first");
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append("excel_file", values.excel_file);
      formData.append("receipt_id", receiptId);
      try {
        const response = await uploadOldCertificateExcel(formData);
        if (response?.data?.status_code === 200) {
          toast.success("Excel file uploaded successfully");
          handleClose();
          onUploaded?.();
        } else if (response?.status_code === 422 && response?.errors) {
          Object.keys(response.errors).forEach((field) => {
            formik.setFieldError(field, response.errors[field]);
          });
          toast.error(
            response?.message || "Unable to upload file, please try again",
          );
        } else {
          toast.error(
            response?.message || "Unable to upload file, please try again",
          );
        }
      } catch (error) {
        toast.error("Unable to upload file, please try again");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleExcelUpload = (e) => {
    const selectedFile = e?.target?.files?.[0];
    if (selectedFile) {
      if (EXCEL_FILE_TYPES.includes(selectedFile?.type)) {
        if (selectedFile?.size <= 2 * 1024 * 1024) {
          formik.setFieldValue("excel_file", selectedFile);
        } else {
          formik.setFieldError(
            "excel_file",
            "File size should be less than 2MB",
          );
        }
      } else {
        formik.setFieldError("excel_file", "Invalid file type");
      }
    }
  };

  const getFieldError = (fieldName) => {
    return formik.errors[fieldName] || "";
  };

  return {
    loading,
    formik,
    handleExcelUpload,
    getFieldError,
  };
};

export default useExcelUpload;
